// extracted by mini-css-extract-plugin
export var item = "sensorCartCard-module--item--JvKzE";
export var xremove = "sensorCartCard-module--xremove--4JHzz";
export var image = "sensorCartCard-module--image--vUbIH";
export var remove = "sensorCartCard-module--remove--eziFK";
export var desc = "sensorCartCard-module--desc--oivh2";
export var count = "sensorCartCard-module--count--kbZ1F";